import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";

const reactSelectStyles = {
  control: (state: any) =>
    `block w-full rounded-lg bg-white px-3.5 text-base !text-gray-900 !cursor-pointer
           placeholder:!text-gray-400 outline-none ring-1 !shadow-none !border-0 py-1
           ${state.isFocused ? "ring-2 !ring-default-600" : "!ring-gray-300"}
           ${state.isError ? "!ring-red-500" : ""}`,
  placeholder: () => "text-base !text-gray-400",
  input: () =>
    "text-base !text-gray-900 focus:!shadow-none focus:!ring-0 [&>input]:!ring-0",
  inputContainer: () =>
    "!shadow-none !ring-0 !outline-none [&>input]:focus:!shadow-none [&>input]:focus:!ring-0",
  singleValue: () => "text-base !text-gray-900",
  valueContainer: () => "!p-0",
  multiValue: () =>
    "!rounded bg-white !bg-default-50 border !border-default-200 !text-default-600 overflow-hidden flex items-center text-base font-medium px-1",
  multiValueLabel: () => "text-base font-medium !text-default-600 ",
  multiValueRemove: (state: any) =>
    `p-0 rounded-full h-5 w-5 flex items-center justify-center mr-1 border-0
           ${state.isFocused ? "!bg-default-600 text-white" : "!bg-default-50 !text-default-600"}`,
  menu: () => "mt-1 overflow-hidden bg-white rounded-md shadow-lg",
  menuList: () => "text-base !text-gray-900 max-h-60",
  option: (state: any) =>
    `px-3.5 py-2 !cursor-pointer
           ${state.isSelected ? "!bg-default-50 !text-default-600" : ""}
           ${state.isFocused ? "!bg-default-50 !text-default-600" : ""}`,
  indicatorsContainer: () =>
    "!bg-default-50 [&_svg]:!text-default-600 !cursor-pointer rounded-full !h-[30px]",
  indicatorSeparator: () => "!bg-transparent",
};

interface Option {
  label: string;
  value: string;
}

interface InputTaggingProps {
  value?: string[];
  options?: string[];
  onChange?: (tags: string[]) => void;
  placeholder?: string;
  multiple?: boolean;
}

export function InputTagging({
  value = [],
  options = [],
  onChange,
  placeholder = "Sélectionner...",
  multiple = true,
}: InputTaggingProps) {
  const initialValues: Option[] = value.map((v) => ({
    label: v.trim(),
    value: v.trim(),
  }));

  const [inputValues, setInputValues] = useState<Option[]>(initialValues);

  const renderedOptions: Option[] = options.map((opt) => ({
    label: opt.trim(),
    value: opt.trim(),
  }));

  const handleChange = (newValue: any) => {
    setInputValues(newValue || []);
    if (onChange) {
      const tags = multiple
        ? (newValue || []).map((option: Option) => option.value)
        : newValue
          ? [newValue.value]
          : [];
      onChange(tags);
    }
  };

  return (
    <CreatableSelect
      isMulti={multiple}
      value={inputValues}
      placeholder={placeholder}
      onChange={handleChange}
      options={renderedOptions}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 200000000,
        }),
      }}
      classNames={reactSelectStyles}
      formatCreateLabel={(inputValue) => `Créer "${inputValue}"`}
      noOptionsMessage={() => "Saisir pour créer un tag"}
    />
  );
}
